import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  Suspense,
} from "react";
import DeleteModel, { confirmBulkDelete } from "../../../Components/DeleteModel";
import {
  deleteItem,
  deleteMultipleItem,
  fetchData,
  handleDragEnd,
  toggleStatus,
} from "../../../utils/apiUtils";
import { DeleteButton, PlusButton } from "../../../helper/ImageFormat";
import Breadcrumb from "../../../helper/Breadcrumb";
import { useNavigate } from "react-router-dom";
import PageTable from "./PageTable";
import { getNextPosition } from "../../../helper/nextPosition";
const PageContent = () => {
  const navigator = useNavigate();
  const [loading, setLoading] = useState(true);
  const [contentData, setcontentData] = useState([]);
  const [search, setSearch] = useState("");
  const [deleteItemId, setDeleteItemId] = useState({});
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selected, setSelected] = useState([]);

  const totalPages = useMemo(
    () => Math.ceil(totalCount / perPage),
    [totalCount, perPage]
  );

  const handleEditClick = (item) => {
    navigator("/add-page-content", { state: item });
  };

  const fetchHomeLayout = useCallback(
    async (page = 1, searchQuery = "") => {
      setLoading(true);
      await fetchData(
        "page-content",
        { perPage, pageNo: page, search: searchQuery },
        setcontentData,
        setTotalCount,
        setCurrentPage,
        setLoading
      );
    },
    [perPage]
  );


  useEffect(() => {
    const delay = search ? 500 : 0;

    const handler = setTimeout(() => {
      fetchHomeLayout(1, search);
    }, delay);

    return () => clearTimeout(handler);
  }, [search, perPage]);

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };


  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("page-content", deleteItemId?.id, fetchHomeLayout);
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (err) {
      return err;
    } finally {
      setIsDeleting(false);
    }
  };



  const handleStatusToggle = async (item) => {
    const data = await toggleStatus(
      "page-content-status",
      item?.id,
      fetchHomeLayout
    );
    if (Object.keys(data).length > 0) {
      setcontentData((prevcontentData) =>
        prevcontentData.map((curr) =>
          curr.id === item.id ? { ...curr, isActive: data?.isActive } : curr
        )
      );
    }
  };

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchHomeLayout(page);
    }
  };
  const AddCMSContent = () => {
    const position = getNextPosition(contentData)
    navigator("/add-page-content", { state: { position } });
  };

  const breadcrumbdata = [
    { label: "Home", path: "/" },
    { label: "Page content", path: "/page-contnent" },
  ];


  const handlebulkDelete = async () => {
    await confirmBulkDelete({
      itemType: "Page Content",
      selectedIds: selected,
      deleteApiCall: (ids) => deleteMultipleItem("delete/page-content", ids),
      refreshCallback: fetchHomeLayout,
    });
  };

  const handleOnDragEnd = (result) => {
    handleDragEnd({
      result,
      data: contentData,
      setData: setcontentData,
      apiEndpoint: "/page-content/position",
    });
  };

  return (
    <>
      <div className="content-wrapper">
        <div
          className="page-header mt-5"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <h3 className="custom-page-title">Page Content</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

        <div
          className="d-flex justify-content-between mb-2"
          style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}
        >
          <select
            className="form-control form-control-sm w-auto"
            value={perPage}
            onChange={(e) => setPerPage(Number(e.target.value))}
          >
            {[5, 10, 20, 50, 100, 150].map((limit) => (
              <option key={limit} value={limit}>
                {limit}
              </option>
            ))}
          </select>

          <div style={{ display: "flex", gap: "20px" }}>
            <div className="search-box">
              <button className="btn-search">
                <i className="fas fa-search"></i>
              </button>
              <input
                type="text"
                className="input-search"
                placeholder="Type to Search..."
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            <PlusButton handleAdd={AddCMSContent} module={"Home Layout"} />
            {selected && selected?.length > 0 && (
              <DeleteButton
                handleAdd={handlebulkDelete}
                name={"selected Sizes"}
                module={"Home Layout"}
              />
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <PageTable
                  loading={loading}
                  contentData={contentData}
                  currentPage={currentPage}
                  perPage={perPage}
                  totalPages={totalPages}
                  totalCount={totalCount}
                  handleOnDragEnd={handleOnDragEnd}
                  handlePageClick={handlePageClick}
                  handleEditClick={handleEditClick}
                  handleDelete={handleDelete}
                  handleStatusToggle={handleStatusToggle}
                  selected={selected}
                  setSelected={setSelected}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Suspense fallback={<div>Loading...</div>}>
        <DeleteModel
          deleteModalOpen={deleteModalOpen}
          setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
          onConfirm={confirmDelete}
          itemName="Page Content"
          isDeleting={isDeleting}
        />
      </Suspense>
    </>
  );
};

export default PageContent;
